module.exports = __webpack_public_path__ + "img/70_33.7e760131.png";